import { render, staticRenderFns } from "./upload.vue?vue&type=template&id=4fbc0bee&scoped=true"
import script from "./upload.vue?vue&type=script&lang=js"
export * from "./upload.vue?vue&type=script&lang=js"
import style0 from "./upload.vue?vue&type=style&index=0&id=4fbc0bee&prod&scoped=true&lang=less"
import style1 from "./upload.vue?vue&type=style&index=1&id=4fbc0bee&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fbc0bee",
  null
  
)

export default component.exports